var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,200,307.5)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,243,51)",
    fillOpacity: 1,
    d: " M30,-58 C30,-58 30,58 30,58 C30,58 -30,58 -30,58 C-30,58 -30,-58 -30,-58 C-30,-58 30,-58 30,-58z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M30,-58 C30,-58 30,58 30,58 C30,58 -30,58 -30,58 C-30,58 -30,-58 -30,-58 C-30,-58 30,-58 30,-58z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,243,51)",
    fillOpacity: 1,
    d: " M28,-55 C28,-55 28,61 28,61 C28,61 -28,61 -28,61 C-28,61 -28,-55 -28,-55 C-28,-55 28,-55 28,-55z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,270,307.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.3053484857082367,-0.6378794312477112,1.5905460119247437,-0.0477377288043499,23.2836971282959,-48.64013671875)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: 10,
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-200,-200)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-135,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,270,307.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 21,
    d: " M0,0 C0,0 -3.47,0.43 -9.43,0.47"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,144,232)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M0,0 C0,0 -3.47,0.43 -9.43,0.47"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.3053484857082367,-0.6378794312477112,1.5905460119247437,-0.0477377288043499,23.2836971282959,-48.64013671875)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,270,307.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 21,
    d: " M-18.46,0.24 C-32.36,-0.55 -52.62,-3.64 -74,-13.46 C-111.8,-30.82 -98.76,-44.26 -98.03,-44.97"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(241,243,51)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M-18.46,0.24 C-32.36,-0.55 -52.62,-3.64 -74,-13.46 C-111.8,-30.82 -98.76,-44.26 -98.03,-44.97"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.3053484857082367,-0.6378794312477112,1.5905460119247437,-0.0477377288043499,23.2836971282959,-48.64013671875)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,340,257.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.020237740129232407,-0.7069075703620911,1.3925687074661255,-0.7699792981147766,-1.6043444871902466,-56.03998947143555)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: 10,
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-200,-200)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-135,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,340,257.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 21,
    d: " M0,0 C0,0 -5.92,2.08 -14.75,4.73"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,144,232)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M0,0 C0,0 -5.92,2.08 -14.75,4.73"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.020237740129232407,-0.7069075703620911,1.3925687074661255,-0.7699792981147766,-1.6043444871902466,-56.03998947143555)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,340,257.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 21,
    d: " M-14.75,4.73 C-29.23,9.07 -51.52,14.96 -68.27,15.7 C-94.63,16.88 -111.26,5.52 -111.98,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(241,243,51)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M-14.75,4.73 C-29.23,9.07 -51.52,14.96 -68.27,15.7 C-94.63,16.88 -111.26,5.52 -111.98,5.02"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.020237740129232407,-0.7069075703620911,1.3925687074661255,-0.7699792981147766,-1.6043444871902466,-56.03998947143555)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,200,241)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,243,51)",
    fillOpacity: 1,
    d: " M0,-41.5 C16.55699920654297,-41.5 30,-20.21525001525879 30,6 C30,32.215248107910156 16.55699920654297,53.5 0,53.5 C-16.55699920654297,53.5 -30,32.215248107910156 -30,6 C-30,-20.21525001525879 -16.55699920654297,-41.5 0,-41.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,204,263)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,144,232)",
    fillOpacity: 1,
    d: " M15.322999954223633,0 C15.322999954223633,7.452000141143799 8.463000297546387,13.493000030517578 0,13.493000030517578 C-8.463000297546387,13.493000030517578 -15.322999954223633,7.452000141143799 -15.322999954223633,0 C-15.322999954223633,-7.452000141143799 -8.463000297546387,-13.493000030517578 0,-13.493000030517578 C8.463000297546387,-13.493000030517578 15.322999954223633,-7.452000141143799 15.322999954223633,0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M15.322999954223633,0 C15.322999954223633,7.452000141143799 8.463000297546387,13.493000030517578 0,13.493000030517578 C-8.463000297546387,13.493000030517578 -15.322999954223633,7.452000141143799 -15.322999954223633,0 C-15.322999954223633,-7.452000141143799 -8.463000297546387,-13.493000030517578 0,-13.493000030517578 C8.463000297546387,-13.493000030517578 15.322999954223633,-7.452000141143799 15.322999954223633,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9945219159126282,-0.10452846437692642,0.10452846437692642,0.9945219159126282,43.65632629394531,26.1407470703125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,130,148.05499267578125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,144,232)",
    fillOpacity: 1,
    d: " M55.84000015258789,17.017000198364258 C45.2760009765625,8.685999870300293 45.2760009765625,-8.699000358581543 55.84000015258789,-17.017000198364258 C68.46499633789062,-26.98200035095215 76.18599700927734,-40.323001861572266 76.18599700927734,-54.98500061035156 C76.18599700927734,-85.81300354003906 42.064998626708984,-110.8010025024414 0,-110.8010025024414 C-42.064998626708984,-110.8010025024414 -76.18599700927734,-85.81300354003906 -76.18599700927734,-54.98500061035156 C-76.18599700927734,-40.323001861572266 -68.46499633789062,-26.98200035095215 -55.84000015258789,-17.017000198364258 C-45.2760009765625,-8.685999870300293 -45.2760009765625,8.699000358581543 -55.84000015258789,17.017000198364258 C-68.46499633789062,26.98200035095215 -76.18599700927734,40.323001861572266 -76.18599700927734,54.98500061035156 C-76.18599700927734,85.81300354003906 -42.064998626708984,110.8010025024414 0,110.8010025024414 C42.064998626708984,110.8010025024414 76.18599700927734,85.81300354003906 76.18599700927734,54.98500061035156 C76.18599700927734,40.323001861572266 68.46499633789062,26.98200035095215 55.84000015258789,17.017000198364258z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M55.84000015258789,17.017000198364258 C45.2760009765625,8.685999870300293 45.2760009765625,-8.699000358581543 55.84000015258789,-17.017000198364258 C68.46499633789062,-26.98200035095215 76.18599700927734,-40.323001861572266 76.18599700927734,-54.98500061035156 C76.18599700927734,-85.81300354003906 42.064998626708984,-110.8010025024414 0,-110.8010025024414 C-42.064998626708984,-110.8010025024414 -76.18599700927734,-85.81300354003906 -76.18599700927734,-54.98500061035156 C-76.18599700927734,-40.323001861572266 -68.46499633789062,-26.98200035095215 -55.84000015258789,-17.017000198364258 C-45.2760009765625,-8.685999870300293 -45.2760009765625,8.699000358581543 -55.84000015258789,17.017000198364258 C-68.46499633789062,26.98200035095215 -76.18599700927734,40.323001861572266 -76.18599700927734,54.98500061035156 C-76.18599700927734,85.81300354003906 -42.064998626708984,110.8010025024414 0,110.8010025024414 C42.064998626708984,110.8010025024414 76.18599700927734,85.81300354003906 76.18599700927734,54.98500061035156 C76.18599700927734,40.323001861572266 68.46499633789062,26.98200035095215 55.84000015258789,17.017000198364258z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9945219159126282,-0.10452846437692642,0.10452846437692642,0.9945219159126282,72.7201919555664,15.6641845703125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,130,229.57699584960938)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-15.748000144958496,-4.0960001945495605 C-11.899999618530273,0.925000011920929 -6.2729997634887695,4.0960001945495605 0,4.0960001945495605 C6.2729997634887695,4.0960001945495605 11.899999618530273,0.925000011920929 15.748000144958496,-4.0960001945495605"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9945219159126282,-0.10452846437692642,0.10452846437692642,0.9945219159126282,72.720458984375,15.664337158203125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,100.62699890136719,212.38099670410156)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M2.575000047683716,0 C2.575000047683716,1.4220000505447388 1.4220000505447388,2.575000047683716 0,2.575000047683716 C-1.4220000505447388,2.575000047683716 -2.575000047683716,1.4220000505447388 -2.575000047683716,0 C-2.575000047683716,-1.4220000505447388 -1.4220000505447388,-2.575000047683716 0,-2.575000047683716 C1.4220000505447388,-2.575000047683716 2.575000047683716,-1.4220000505447388 2.575000047683716,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,159.3730010986328,212.38099670410156)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M2.575000047683716,0 C2.575000047683716,1.4220000505447388 1.4220000505447388,2.575000047683716 0,2.575000047683716 C-1.4220000505447388,2.575000047683716 -2.575000047683716,1.4220000505447388 -2.575000047683716,0 C-2.575000047683716,-1.4220000505447388 -1.4220000505447388,-2.575000047683716 0,-2.575000047683716 C1.4220000505447388,-2.575000047683716 2.575000047683716,-1.4220000505447388 2.575000047683716,0z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,196.36424255371094,348.3480224609375)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.4189879894256592,-0.9079917669296265,-0.9079917669296265,0.4189879894256592,-27.10613250732422,-58.74188995361328)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: 10,
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-200,-200)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-135,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,196.36424255371094,348.3480224609375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 21,
    d: " M0,0 C0,0 2.9,-2.43 6.93,-6.63"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,144,232)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M0,0 C0,0 2.9,-2.43 6.93,-6.63"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.4189879894256592,-0.9079917669296265,-0.9079917669296265,0.4189879894256592,-27.10613250732422,-58.74188995361328)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,196.36424255371094,348.3480224609375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 20,
    d: " M6.93,-6.63 C9.21,-9 11.84,-11.93 14.51,-15.3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(241,243,51)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M6.93,-6.63 C9.21,-9 11.84,-11.93 14.51,-15.3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.4189879894256592,-0.9079917669296265,-0.9079917669296265,0.4189879894256592,-27.10613250732422,-58.74188995361328)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,196.36424255371094,348.3480224609375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(241,243,51)",
    strokeOpacity: 1,
    strokeWidth: 15,
    d: " M13.31,-13.81 C18.73,-20.42 24.53,-28.96 28.02,-38.43 C29.69,-42.98 30.82,-47.7 31.57,-52.34"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(-0.4189879894256592,-0.9079917669296265,-0.9079917669296265,0.4189879894256592,-27.10613250732422,-58.74188995361328)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManAnimation);
export default __webpack_public_path__ + "static/media/manAnimation.6ab4318b2319e33e4d058b91dd10568d.svg";
export { ForwardRef as ReactComponent };